/*
*  connection of the form for the manager
*/

import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import serializer from 'form-serializer'
import mask from 'jquery-mask-plugin'
import datetimepicker from 'jquery-datetimepicker'
import {Modal} from "bootstrap";

export default class extends Controller {
    static targets = [ "id"]
    WhoIs;


    initialize() {
        super.initialize();

    }

    //checking authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            //sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }

    //looking for a client by phone
    /* старый вариант, закрыт 07.2023 */
    /*searchClient(){
        this.checkToken();
        let phoneInput = $('#clientPhone');
        let nameInput = $('#clientName');
        let surnameInput = $('#clientSurname');
        let dateBirthnput = $('#clientDateBirth');
        let alertBox = $('#addClientAlert');

        let phone = phoneInput.val().replace(/\D/g, "");
        if (phone.length < 11){
            return
        }
        //looking for a client by phone in our database
        let searchPhoneActualBase = api.getByPhone(phone);

        if (searchPhoneActualBase === null){
            //if not in ours, we start the search in the WEB-database
            let result = api.searchClient(phone);
            console.debug(result);
            if(result.status !== 200) {
                alertBox.html('<div class="alert alert-warning mt-3 alertClient" role="alert">\n' +
                    'Не получены данные из базы. Повторите попытку позже\n' +
                    '</div>');
                $('.alertClient').delay(10000).slideUp(300);
                nameInput.attr("value", "");
                surnameInput.attr("value", "");
                dateBirthnput.attr("value", "");
            }
            if (result.length === 0) {
                alertBox.html('<div class="alert alert-warning mt-3 alertClient" role="alert">\n' +
                    'Клиента нет в базе. Заполните форму самостоятельно\n' +
                    '</div>');
                $('.alertClient').delay(10000).slideUp(300);
                nameInput.val('');
                surnameInput.val('');
                dateBirthnput.val('');
            } else  {
                let phone = (result[0].CepTel);
                let phoneInput = $('#clientPhone');
                phoneInput.val(phoneInput.masked(phone));
                $('#clientName').val(result[0].CariAd)
                $('#clientSurname').val(result[0].CariSoyad)

                //patient's birthday
                if (result[0].DogTar !== ''){
                    let clientDateBirth = new Date(result[0].DogTar).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
                    $('#clientDateBirth').val(clientDateBirth);
                }
            }
            /!* END searching in the WEB-database *!/
        } else {
            //patient's birthday
            let clientDateBirthData;
            if (searchPhoneActualBase.ClientDateBirth !== ''){
                  clientDateBirthData = new Date(searchPhoneActualBase.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            }
            phoneInput.val(phoneInput.masked(phone));
            nameInput.val(searchPhoneActualBase.ClientName);
            surnameInput.val(searchPhoneActualBase.ClientSurname);
            dateBirthnput.val(clientDateBirthData);
        }


    }*/

    //looking for a client by phone
    searchClient(){
        this.checkToken();
        let phoneInput = $('#clientPhone');
        let nameInput = $('#clientName');
        let surnameInput = $('#clientSurname');
        let dateBirthnput = $('#clientDateBirth');
        let alertBox = $('#addClientAlert');

        let phone = phoneInput.val().replace(/\D/g, "");
        if (phone.length < 11){
            return
        }

        //looking for a client by phone in our database
        let searchPhoneActualBase = api.getByPhone(phone);
        if (searchPhoneActualBase !== null){
            //patient's birthday
            let clientDateBirthData;
            if (searchPhoneActualBase.ClientDateBirth !== ''){
                clientDateBirthData = new Date(searchPhoneActualBase.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            }
            phoneInput.val(phoneInput.masked(phone));
            nameInput.val(searchPhoneActualBase.ClientName);
            surnameInput.val(searchPhoneActualBase.ClientSurname);
            dateBirthnput.val(clientDateBirthData);
            $('#formCreateClient input.form-control,#formCreateClient button').attr("disabled", true);
            //$('#formCreateClient button').attr("disabled", true);
            $('#formCreateClient').prepend('<div class="alert alert-warning" id="alertOurBase"><strong>Этот клиент уже есть в нашей базе.</strong><br><br>Пожалуйста, перейдите на страницу базы данных и ищите в списке пациентов по номеру телефона. </div>');
            $('#alertOurBase').delay(10000).slideUp(300);
            return;
        }

        if (searchPhoneActualBase === null){
            //if not in ours, we start the search in the WEB-database
            let result = api.searchClient(phone);
            console.debug(result);
            if(result.status !== 200) {
                alertBox.html('<div class="alert alert-warning mt-3 alertClient" role="alert">\n' +
                    'Не получены данные из WEB базы. Повторите попытку позже\n' +
                    '</div>');
                $('.alertClient').delay(10000).slideUp(300);
                nameInput.attr("value", "");
                surnameInput.attr("value", "");
                dateBirthnput.attr("value", "");
                return;
            }
            if (result.length === 0) {
                alertBox.html('<div class="alert alert-warning mt-3 alertClient" role="alert">\n' +
                    'Клиента нет в WEB базе. Заполните форму самостоятельно\n' +
                    '</div>');
                $('.alertClient').delay(10000).slideUp(300);
                nameInput.val('');
                surnameInput.val('');
                dateBirthnput.val('');
                return;
            }
            if (result.length !== 0)  {
                let phone = (result[0].CepTel);
                let phoneInput = $('#clientPhone');
                phoneInput.val(phoneInput.masked(phone));
                $('#clientName').val(result[0].CariAd);
                $('#clientSurname').val(result[0].CariSoyad);;
                if (result[0].DogTar !== ''){
                    let clientDateBirth = new Date(result[0].DogTar).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
                    $('#clientDateBirth').val(clientDateBirth);
                }
                return;
            }


        }
    }

    //filling out the client form
      fillForm(){
        this.checkToken();
          let clientPhone = $('#form-clientcreation').attr('data-clientphone');
          let phoneInput = $('#clientPhone');
          let nameInput = $('#clientName');
          let surnameInput = $('#clientSurname');
          let dateBirthInput = $('#clientDateBirth');

          if (clientPhone.length < 11){
              return
          }
          phoneInput.attr('disabled',true);

          //looking for a client by phone in our database
          let searchPhoneActualBase = api.getByPhone(clientPhone);
          console.debug(searchPhoneActualBase);

          $('#formCreateClient').prepend('<input type="hidden" name="patientId" value="'+searchPhoneActualBase.ID+'"><input type="hidden" name="webCode" value="'+searchPhoneActualBase.ClientId+'"><input type="hidden" name="clientPhone" value="'+clientPhone+'">')

          phoneInput.val(phoneInput.masked(searchPhoneActualBase.Phone));
          nameInput.val(searchPhoneActualBase.ClientName);
          surnameInput.val(searchPhoneActualBase.ClientSurname);

          let clientDateBirthData;
          if (searchPhoneActualBase.ClientDateBirth !== ''){
              clientDateBirthData = new Date(searchPhoneActualBase.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
          }
          dateBirthInput.val(clientDateBirthData);

          $('#formCreateClient .btn').text('Сохранить изменения');

    }

    //create a client
    clientCreate(){
        this.checkToken();

        //checking the fields
        let checkPhone = $('#clientPhone');
        let checkName = $('#clientName');
        let checkSurname = $('#clientSurname');
        let checkBirthday = $('#clientDateBirth');

        if (checkPhone.val().length === 0){
            checkPhone.addClass('invalid');
        } else {
            checkPhone.removeClass('invalid');
        }
        if (checkName.val().length === 0){
            checkName.addClass('invalid');
        } else {
            checkName.removeClass('invalid');
        }
        if (checkSurname.val().length === 0){
            checkSurname.addClass('invalid');
        } else {
            checkSurname.removeClass('invalid');
        }
        if (checkBirthday.val().length === 0){
            checkBirthday.addClass('invalid');
        } else {
            checkBirthday.removeClass('invalid');
        }
        if (checkPhone.val().length === 0 ||
            checkName.val().length === 0 ||
            checkSurname.val().length === 0 ||
            checkBirthday.val().length === 0) {
            alert('Не сохранено. Заполните пустые поля');
        }         else {
                        //all fields are filled, create a client
                        let formCreateClient = $($("#formCreateClient")[0]).serializeObject();
                        formCreateClient.clientPhone = formCreateClient.clientPhone.replace(/[^0-9]/g, '');
                        console.debug(formCreateClient);
                        let result = api.managerClientCreate(JSON.stringify(formCreateClient));
                        let edit = $("#form-clientcreation").attr('data-clientphone');
                        if (result === null){
                            if (edit === undefined){
                                //alert for NEW user, error
                                alert('Клиент не записан. Попробуйте позже.');
                            } else {
                                //alert for EDIT user, error
                                alert('Изменения не сохранены. Попробуйте позже.');
                            }

                        } else {
                            if (edit === undefined){
                                //alert for NEW user, success
                                alert('Клиент создан');
                            } else {
                                //alert for EDIT user, success
                                alert('Изменения сохранены');
                            }
            }
        }
    }

    /*header(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
        }

        //we turn to twig, indicate which controller to use, inside we transfer the data
        let nameVar = Twig.twig({ref: "template"}).render({
            userAuth: this.WhoIs
        });
        //specify the block and display the contents of the twig in it
        $('#template__header').html(nameVar)
    }*/

   async connect() {
        this.checkToken();

        let editFormCheck = $('#form-clientcreation').attr('data-form');

        //we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "form-clientcreation"}).render({
            userAuth: this.WhoIs,
            editFormCheck: editFormCheck
        });
        //specify the block and display the contents of the twig in it
        $('#form-clientcreation').html(content);


        //settings
        let self = this;
        $.datetimepicker.setLocale('ru');
        $('#clientDateBirth').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
            maxDate:'0',
            onChangeDateTime:  self.clientAge
        });
        $('.phone-box').mask('+7 (000) 000-00-00');
       $('.form-control').click( function(){
           $(this).select()
       })

       //define edit or new form
         let clientPhone = $('#form-clientcreation').attr('data-clientphone');
         if(clientPhone !== undefined) {
            this.fillForm();
       }

    }
}